import type { Searches } from '~/types/searches';

export default function getFirstReportImage(
  search: Searches.StoredSearchObject
): string {
  for (const item of search.all) {
    if (item.type === 'report') {
      return item.value;
    }
  }
  for (const item of search.any) {
    if (item.type === 'report') {
      return item.value;
    }
  }
  return '0';
}
